module.exports = __webpack_public_path__ + "static/media/help.c53630da.svg";